import React from "react";
import { Tabs  } from 'antd';
import { useState } from "react";
import { PropertyIssues } from './PropertyIssues ';
import { WorkingTenantIssues } from "./WorkingTenantIssues";
import { TenantConstructionStatus } from "./TenantConstructionStatus";
import { TenantImprovementAllowace } from "./TenantImprovementAllowace";
import { PlusOutlined } from '@ant-design/icons';


function Properties(e) {
  const [tenantAllowaceIs, setTenantAllowaceIs ] = useState (true);
    const [propertiesActive, setPropertiesActive ] = useState (false);
    const [WorkingTenant, setWorkingTenat ] = useState (false);
    const [tenantConstruction, setTenantConstruction ] = useState (false);
   
    const onChange = (key) => {

        console.log(key);

        if (key === '1') {
          setTenantAllowaceIs(true);
          setPropertiesActive(false);
          setWorkingTenat(false);
          setTenantConstruction(false);

            
          }else if (key === '2'){
            setPropertiesActive(true);
            setWorkingTenat(false);
            setTenantConstruction(false)
            setTenantAllowaceIs(false);
          } else if (key === '3') {
            setWorkingTenat(true);
            setPropertiesActive(false);
            setTenantConstruction(false)
            setTenantAllowaceIs(false);
          }else if (key === '4') {
            setTenantConstruction(true)
            setWorkingTenat(false);
            setPropertiesActive(false);
            setTenantAllowaceIs(false);
          }
           else {
            
          }

      };
      const items = [
        {
          key: '1',
          label: 'Tenant Improvement Allowace',
          icon:<PlusOutlined />,
          
        },
        {
          key: '2',
          label: 'Property Issues',
          icon:<PlusOutlined />,
          
        },
        {
          key: '3',
          label: 'WorkingTenant Issues',
          icon:<PlusOutlined />,
          
        },
        {
          key: '4',
          label: 'Tenant Construction Status',
          icon:<PlusOutlined />,
          
        },
      ];

    return (
        <>
       <Tabs 
       size= 'large' 
       defaultActiveKey="1" 
       items={items} 
       type="card"
       onChange={onChange} />
      {tenantAllowaceIs && <TenantImprovementAllowace />}
       {propertiesActive && <PropertyIssues />}
       
       {WorkingTenant && <WorkingTenantIssues />}
       
       {tenantConstruction && <TenantConstructionStatus />}
        </>
    )
    
}

export { Properties }